import React from 'react';
import './AnimatedIcons.css';

export const AnimatedQualityIcon = () => (
  <div className="animated-icon-container">
    <svg width="80" height="80" viewBox="0 0 100 100" className="quality-svg">
      <circle cx="50" cy="50" r="45" className="circle-border" />
      <polyline points="30,52 45,67 70,35" className="check-mark" />
    </svg>
  </div>
);

export const AnimatedRangeIcon = () => (
  <div className="animated-icon-container">
    <svg width="100" height="80" viewBox="0 0 120 100" className="range-svg">
      {/* Small Box Left */}
      <g className="box-group small-box">
        <rect x="10" y="60" width="25" height="30" className="box-body" rx="1" />
        <rect x="10" y="58" width="25" height="4" className="box-lid" rx="1" />
      </g>
      {/* Large Box Center */}
      <g className="box-group large-box">
        <rect x="40" y="40" width="40" height="50" className="box-body" rx="1" />
        <rect x="40" y="37" width="40" height="6" className="box-lid" rx="1" />
      </g>
      {/* Medium Box Right */}
      <g className="box-group medium-box">
        <rect x="85" y="55" width="30" height="35" className="box-body" rx="1" />
        <rect x="85" y="52" width="30" height="5" className="box-lid" rx="1" />
      </g>
    </svg>
  </div>
);

export const AnimatedDeliveryIcon = () => (
  <div className="animated-icon-container">
    <svg width="80" height="80" viewBox="0 0 100 100" className="delivery-svg">
      {/* Alarm Clock Bells */}
      <path d="M30 25 A15 15 0 0 1 55 20" className="clock-bell" />
      <path d="M65 20 A15 15 0 0 1 90 25" className="clock-bell" />
      {/* Clock Face */}
      <circle cx="60" cy="55" r="35" className="clock-face-main" />
      {/* Wind Dashes */}
      <line x1="5" y1="45" x2="15" y2="45" className="wind-dash dash-1" />
      <line x1="0" y1="60" x2="10" y2="60" className="wind-dash dash-2" />
      {/* Hands */}
      <line x1="60" y1="55" x2="60" y2="35" className="hand hour-hand" />
      <line x1="60" y1="55" x2="80" y2="55" className="hand minute-hand" />
      <circle cx="60" cy="55" r="2" fill="currentColor" />
    </svg>
  </div>
);
